import { apiClient } from "./client";

export const adminTurmasApi = {
  listar(instId) {
    return apiClient.get(`/admin/instituicoes/${instId}/turmas`);
  },
  obter(instId, id) {
    return apiClient.get(`/admin/instituicoes/${instId}/turmas/${id}`);
  },
  criar(instId, payload) {
    return apiClient.post(`/admin/instituicoes/${instId}/turmas`, payload);
  },
  editar(instId, id, payload) {
    return apiClient.patch(
      `/admin/instituicoes/${instId}/turmas/${id}`,
      payload,
    );
  },
  excluir(instId, id) {
    return apiClient.delete(`/admin/instituicoes/${instId}/turmas/${id}`);
  },
  vincularAluno(instId, turmaId, alunoId) {
    return apiClient.post(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/alunos/${alunoId}`,
    );
  },
  vincularCoordenacao(instId, turmaId, coordenacaoId) {
    return apiClient.post(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/coordenacoes/${coordenacaoId}`,
    );
  },
  desvincularCoordenacao(instId, turmaId, coordenacaoId) {
    return apiClient.delete(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/coordenacoes/${coordenacaoId}`,
    );
  },
  desvincularAluno(instId, turmaId, alunoId) {
    return apiClient.delete(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/alunos/${alunoId}`,
    );
  },
  vincularResponsavel(instId, turmaId, payload) {
    return apiClient.post(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/responsaveis`,
      payload,
    );
  },
  editarResponsavel(instId, turmaId, vincId, payload) {
    return apiClient.patch(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/responsaveis/${vincId}`,
      payload,
    );
  },
  desvincularResponsavel(instId, turmaId, vincId) {
    return apiClient.delete(
      `/admin/instituicoes/${instId}/turmas/${turmaId}/responsaveis/${vincId}`,
    );
  },
};
